import React, { useCallback } from "react";
import "./App.css";
import { HashRouter, Routes, Route } from "react-router-dom";

import Nav from "./components/Nav/nav.jsx";
import Index from "./components/pages/Index.jsx";
import Mentions from "./components/pages/Mentions-legal.jsx";
import { useCenteredAnchors } from "./hook/useCenteredAnchors.js";
  

const Main = () => {
  useCenteredAnchors();

  const handleServiceClick = useCallback(
    (id) => (e) => {
      e.preventDefault();

     
      window.dispatchEvent(
        new CustomEvent("open-prestation", { detail: { id } })
      );
      const target = document.getElementById(`prestation-${id}`);
      if (target) {
        target.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    },
    []
  );

  const services = [
    {
      number: "01",
      title: "INTERNET & RÉSEAUX",
      icon: (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <path d="M5 12.55a11 11 0 0 1 14.08 0" />
          <path d="M1.42 9a16 16 0 0 1 21.16 0" />
          <path d="M8.53 16.11a6 6 0 0 1 6.95 0" />
          <circle cx="12" cy="20" r="1" />
        </svg>
      ),
      url: "#prestation-01",
    },
    {
      number: "02",
      title: "TÉLÉPHONIE D'ENTREPRISE VOIP",
      icon: (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
        </svg>
      ),
      url: "#prestation-02",
    },
    {
      number: "03",
      title: "SOLUTIONS D'IMPRESSION ET DE NUMÉRISATION",
      icon: (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <polyline points="6,9 6,2 18,2 18,9" />
          <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" />
          <rect x="6" y="14" width="12" height="8" />
        </svg>
      ),
      url: "#prestation-03",
    },
    {
      number: "04",
      title: "SOLUTIONS DE DÉMATÉRIALISATION",
      icon: (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
          <polyline points="14,2 14,8 20,8" />
          <path d="M16 13H8" />
          <path d="M16 17H8" />
          <polyline points="10,9 9,9 8,9" />
        </svg>
      ),
      url: "#prestation-04",
    },
    {
      number: "05",
      title: "ÉCRANS MULTIFONCTIONS INTÉRACTIFS",
      icon: (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
          <line x1="8" y1="21" x2="16" y2="21" />
          <line x1="12" y1="17" x2="12" y2="21" />
        </svg>
      ),
      url: "#prestation-05",
    },
    {
      number: "06",
      title: "SOLUTIONS D'AFFICHAGE DYNAMIQUE",
      icon: (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <path d="M9 12l2 2 4-4" />
          <path d="M21 12c0 4.97-4.03 9-9 9s-9-4.03-9-9 4.03-9 9-9c1.34 0 2.6.3 3.73.83" />
          <path d="M16 2v4l3-1.5L16 2z" />
        </svg>
      ),
      url: "#prestation-06",
    },
    {
      number: "07",
      title: "SÉCURITÉ & SAUVEGARDES INFORMATIQUES",
      icon: (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
          <path d="M9 12l2 2 4-4" />
        </svg>
      ),
      url: "#prestation-07",
    },
  ];

  return (
    <div className="app">

      <header className="header">
        <div className="contain">
          <Nav />
        </div>
      </header>


      <section className="hero" id="hero">
        <div className="contain">
          <div className="hero-content">
            <div className="hero-left">
              <div className="hero-title">
                <img
                  src={require("./logo-azurea-main.png")}
                  alt="AZUREA Print & Solutions"
                  className="hero-logo"
                />
                <h2 className="hero-slogan-text">
                  Notre priorité <span>:</span> Votre satisfaction{" "}
                  <span>!</span>
                </h2>
              </div>
            </div>

            <div className="hero-right">
              <div className="services-list">
                {services.map((s) => (
                  <a
                    key={s.number}
                    href={s.url}
                    className="service-item"
                    onClick={handleServiceClick(s.number)}
                  >
                    <div className="service-left">
                      <div className="service-icon">{s.icon}</div>
                      <div className="service-title">
                        <span>{s.title}</span>
                      </div>
                    </div>
                    <span className="service-number">{s.number}</span>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Présentation */}
      <section className="presentation" id="apropos">
        <div className="contain">
          <div className="presentation-content">
            <div className="presentation-left">
              <img
                src={require("./team-image.png")}
                alt="Équipe travaillant"
                className="presentation-image"
              />
            </div>
            <div className="presentation-right">
              <div className="presentation-text">
                <p>
                  Notre agence{" "}
                  <span className="highlight">Azurea Print & Solutions</span>{" "}
                  située à Grasse depuis 2018, nous permet d'intervenir dans les
                  départements des Alpes Maritimes et du Var, ainsi que sur tout
                  le reste de la France grâce à nos partenaires de confiance.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Le reste du site */}
      <Index />

      {/* Chatbot */}
     
    </div>
  );
};

const App = () => {
  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/mentions-legales" element={<Mentions />} />
        <Route path="*" element={<Main />} />
      </Routes>
    </HashRouter>
  );
};

export default App;
